<script>
import compoment from '@/components/draggable/CustomComponents/Select/DSelectEditor'
export default {
  name: 'DParentColumnEditor',
  extends: compoment
}
</script>
